import { render, staticRenderFns } from "./FilmRate.vue?vue&type=template&id=412a9a90&"
import script from "./FilmRate.vue?vue&type=script&lang=js&"
export * from "./FilmRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports